import script from "./AppItemList.vue?vue&type=script&setup=true&lang=js"
export * from "./AppItemList.vue?vue&type=script&setup=true&lang=js"

import "./AppItemList.vue?vue&type=style&index=0&id=561b66e8&scoped=true&lang=scss"

import exportComponent from "D:\\新建文件夹\\workPage\\OA H5\\stgd.oa.mobile.h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-561b66e8"]])

export default __exports__